const scrollToContact = () => {
  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
};

const scrollToServices = () => {
  document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
};

export default function HeroSection() {
  return (
    <section className="relative w-full bg-background-50 overflow-hidden pt-16 pb-4 md:pt-20 md:pb-6 lg:pt-20 lg:pb-6">
      <div className="w-full px-4 md:px-12 lg:px-16">
        <div className="flex flex-row md:flex-col lg:flex-row items-center md:items-center lg:items-center gap-2 md:gap-8 lg:gap-10">
          {/* Left Content */}
          <div className="w-[48%] min-w-0 md:w-full lg:w-[45%] xl:w-[42%]">
            <span className="inline-flex items-center gap-1 md:inline-flex md:gap-1.5 text-[10px] md:text-[11px] font-semibold tracking-[0.12em] uppercase text-accent-600 mb-1.5 md:mb-4">
              <i className="ri-star-fill text-[9px] md:text-[10px]" />
              TRUSTED LOCALLY
            </span>
            <h1 className="font-heading text-[1.7rem] md:text-[2.3rem] lg:text-[2.85rem] xl:text-[3.25rem] leading-[1.2] md:leading-[1.15] text-foreground-950 mb-2 md:mb-4">
              We Make Renting a Home Simple.
            </h1>
            <p className="hidden md:block text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              We simplify the rental process for tenants and owners across Kharghar, Navi Mumbai and nearby areas.
            </p>
            {/* Desktop + tablet buttons — Get in Touch + View Our Services */}
            <div className="hidden md:flex flex-col sm:flex-row gap-3">
              <button
                onClick={scrollToContact}
                className="inline-flex items-center justify-center px-7 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors lg:transition-all lg:duration-300 lg:hover:-translate-y-1.5 lg:hover:shadow-md lg:hover:scale-[1.03] whitespace-nowrap cursor-pointer"
              >
                Get in Touch
              </button>
              <button
                onClick={scrollToServices}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 border border-foreground-300 text-foreground-950 text-sm font-semibold rounded-md hover:bg-background-100 transition-colors lg:transition-all lg:duration-300 lg:hover:-translate-y-1.5 lg:hover:shadow-md lg:hover:scale-[1.03] whitespace-nowrap cursor-pointer"
              >
                View Our Services
                <span aria-hidden="true" className="text-base leading-none text-foreground-500">&gt;</span>
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="w-[46%] min-w-0 md:w-full lg:w-[55%] xl:w-[58%] relative md:mr-0 lg:mr-0">
            <div className="relative w-full aspect-[10/12] md:aspect-[16/10] rounded-l-[40px] md:rounded-lg overflow-hidden">
              <img
                src="/assets/hero.jpg"
                alt="Family viewing a modern rental home"
                className="w-full h-full object-cover object-right-top md:object-top"
              />
              {/* Left-edge blend */}
              <div className="absolute inset-y-0 left-0 w-[20%] md:w-[30%] bg-gradient-to-r from-background-50 to-transparent pointer-events-none" />
              {/* Soft-wash overlay — desktop only */}
              <div className="hidden md:block absolute inset-0 bg-background-50/8 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Mobile-only info lines and CTA buttons */}
        <div className="md:hidden mt-6 space-y-3">
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 shrink-0 relative">
              <i className="ri-user-fill absolute" style={{ fontSize: '12px', color: '#5C3D2E', left: '4px', bottom: '3px' }} />
              <i className="ri-user-fill absolute" style={{ fontSize: '9px', color: '#5C3D2E', right: '4px', bottom: '3px' }} />
            </div>
            <span className="font-heading text-sm text-foreground-600 font-medium tracking-wide">
              For tenants and owners
            </span>
          </div>
          <div className="w-12 h-px bg-foreground-200/60 ml-9" />
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 shrink-0">
              <i className="ri-map-pin-line text-sm" style={{ color: '#5C3D2E' }} />
            </div>
            <span className="font-heading text-sm text-foreground-600 font-medium tracking-wide">
              Kharghar • Navi Mumbai & nearby areas
            </span>
          </div>
          <div className="flex flex-col gap-3 pt-4">
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get in touch
            </button>
            <a
              href="https://wa.me/918591019785"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2.5 px-7 py-3.5 border border-foreground-300 text-foreground-950 text-sm font-semibold rounded-md hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg" />
              WhatsApp Us
            </a>
            <button
              onClick={scrollToServices}
              className="w-full inline-flex items-center justify-center gap-2.5 px-7 py-3.5 bg-secondary-100 border border-secondary-300 text-foreground-950 text-sm font-semibold rounded-full hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Our Services
              <span className="w-6 h-6 flex items-center justify-center rounded-full border border-secondary-300">
                <i className="ri-arrow-down-s-line text-sm text-foreground-700" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}